import { BaseRequest, IBaseRequest } from "../../BaseRequest";

export interface IUpdateRegisterRequest extends IBaseRequest {
    id?: number;
    module?: number;
    moduleId?:string;
    application?: number;
    key?: string;
    level?: number;
    value?: string;
    assignTo?: number;
}

export class UpdateRegisterRequest extends BaseRequest implements IUpdateRegisterRequest {
    id?: number;
    module?: number;
    moduleId?:string;
    application?: number;
    key?: string;
    level?: number;
    value?: string;
    assignTo?: number;

    constructor(server: string, 
        session: string,
        id?: number,
        module?: number,
        moduleId?:string,
        application?: number,
        key?: string,
        level?: number,
        value?: string,
        assignTo?: number) {
            super(server, session);
            this.id = id;
            this.module = module;
            this.moduleId = moduleId;
            this.application = application;
            this.key = key;
            this.level = level;
            this.value = value;
            this.assignTo = assignTo;
    }

    toXml(): string {
        var parameters:string = super.toXml();
        parameters += this.makeNode(this.id, 'id');
        parameters += this.makeNode(this.module, 'module');
        parameters += this.makeNode(this.moduleId, 'moduleId');
        parameters += this.makeNode(this.application, 'application');
        parameters += this.makeNode(this.key, 'key');
        parameters += this.makeNode(this.level, 'level');
        parameters += this.makeNode(this.value, 'value');
        parameters += this.makeNode(this.assignTo, 'assignTo');

        return super.wrapperXml('UpdateRegister', parameters);
    }
}